import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

import type { EsnFaqEntry } from '../../../shared/types/support';
import { FaqItemComponent } from '../faq-item/faq-item.component';

/**
 * One Help Center subject: a titled card of questions. By default opening one question closes
 * the others; `multiple` lets several stay open. Open questions are `[(open)]` by entry id.
 */
@Component({
  selector: 'esn-faq-group',
  imports: [FaqItemComponent],
  templateUrl: './faq-group.component.html',
  styleUrl: './faq-group.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqGroupComponent {
  readonly heading = input('');
  readonly items = input<EsnFaqEntry[]>([]);
  readonly multiple = input(false);
  readonly open = model<string[]>([]);

  protected isOpen(id: string): boolean {
    return this.open().includes(id);
  }

  protected setOpen(id: string, open: boolean): void {
    const current = this.open().filter((openId) => openId !== id);
    if (!open) this.open.set(current);
    else this.open.set(this.multiple() ? [...current, id] : [id]);
  }
}
